import {
  Layout,
  Dropdown,
  Space,
  Image,
  Typography,
  Button,
  Modal,
} from "antd";
import styled from "styled-components";
import { ReactComponent as ThreeDotsVertical } from "../../../../../../assets/icons/ThreeDotsVertical.svg";
import NoImageSmall from "../../../../../../assets/images/NoImageSmall.svg";

const { Text } = Typography;

export const TrainingProgramsLayout = styled(Layout)`
  margin: 0rem 0;
  background-color: transparent;
`;

export const StyledThreeDotsVertical = styled(ThreeDotsVertical)`
  cursor: pointer;
`;

export const StyledTrainingProgramNameCell = styled(Space).attrs({
  direction: "horizontal",
  size: "middle",
})`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  .ant-space-item {
    font-size: 14px;
    font-weight: 400;
    color: #313131;
  }
`;

export const TrainingProgramImage = styled(Image).attrs({
  height: "2.75rem",
  width: "7.25rem",
  fallback: NoImageSmall,
  preview: false,
})`
  padding: 0;
  margin: 0;
  border: none !important;
  outline: none;
  background: #f1f1f1;
  opacity: 0.72;
  border-radius: 4px 4px 4px 4px;

  .ant-image-img {
    padding: 0;
    margin: 0;
    border: none !important;
    outline: none;
  }

  .ant-image-mask,
  .ant-image-preview {
    padding: 0;
    margin: 0;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }
`;

export const TrainingProgramNameWrapper = styled(Space).attrs({
  direction: "vertical",
  size: "small",
})`
  display: flex;
  align-items: flex-start;
`;

export const TrainingProgramName = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

export const TrainingProgramDescription = styled(Text)`
  font-size: 12px;
  font-weight: 400;
  color: #808080;
`;

export const StyledVerticalSpace = styled(Space).attrs({
  direction: "vertical",
  size: "middle",
})``;

export const StyledHorizontalSpace = styled(Space).attrs({
  direction: "horizontal",
  size: "large",
})`
  display: flex;
  width: 100%;

  .ant-space-item {
    width: 100%;
  }
`;

export const StyledActiveUsersModal = styled(Modal)`
  direction: rtl;
  .ant-modal-footer {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }
  .ant-btn {
    width: 180px;
    height: 44px;
    margin: 0;
  }
`;
